import { MetaDataValues } from 'Roblox';
import angular from 'angular';
import recommendationsModule from '../recommendationsModule.js';

function carouselController(
  $log,
  $scope,
  carouselForItemDetails,
  carouselForInventory,
  carouselForAvatarPage,
  controlService,
  recommendationsConstants
) {
  'ngInject';

  const ctrl = this;
  ctrl.getCarouselConstant = () => {
    let carouselConstants = {};
    const { pageNames } = recommendationsConstants;
    const currentPageName = MetaDataValues.getPageName();
    switch (currentPageName) {
      case pageNames.avatar:
        carouselConstants = angular.copy(carouselForAvatarPage);
        break;
      case pageNames.inventory:
      case pageNames.favorites:
        carouselConstants = angular.copy(carouselForInventory);
        break;
      case pageNames.catalogItem:
      case pageNames.bundleDetails:
      default:
        carouselConstants = angular.copy(carouselForItemDetails);
        break;
    }

    return carouselConstants;
  };

  $scope.$on('setupCarousel', () => {
    if (ctrl.items && ctrl.items.length > 0) {
      const carouselConstants = ctrl.getCarouselConstant();
      ctrl.glideControl = controlService.setupCarouselControl(ctrl.items.length, carouselConstants);

      ctrl.glide = controlService.initializeGlideCarousel(
        recommendationsConstants.carouselSelector,
        carouselConstants,
        ctrl.glideControl
      );

      ctrl.backward = controlService.backward(ctrl.glide, ctrl.glideControl);
      ctrl.forward = controlService.forward(ctrl.glide, ctrl.glideControl);
      controlService.listenToResize(ctrl.glide, carouselConstants, ctrl.glideControl);
    }
  });
}

recommendationsModule.controller('carouselController', carouselController);
export default carouselController;
